import { render, staticRenderFns } from "./TeamAttrs.vue?vue&type=template&id=c9a95e7a"
import script from "./TeamAttrs.vue?vue&type=script&lang=js"
export * from "./TeamAttrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports